var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","small":""},on:{"click":_vm.onExcelDownload}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("mdi-download")]),_vm._v("Выгрузить ответы ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }